var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column flex-grow-1" },
    [
      _c(
        "b-card",
        {
          staticClass: "flex-grow-1",
          attrs: {
            "body-class":
              "d-flex justify-content-around dough-counters align-items-center"
          }
        },
        [
          _c(
            "h3",
            { staticClass: "mb-0", attrs: { slot: "header" }, slot: "header" },
            [_vm._v("Необходимо")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Традиционное тесто")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "counter" }, [
              _c("span", { staticClass: "counter__number" }, [
                _vm._v(_vm._s(_vm.pizzaDoughsNeedsCount.big))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Тонкое тесто")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "counter counter_small" }, [
              _c("span", { staticClass: "counter__number" }, [
                _vm._v(_vm._s(_vm.pizzaDoughsNeedsCount.small))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Тесто для пирога")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "counter counter_small" }, [
              _c("span", { staticClass: "counter__number" }, [
                _vm._v(_vm._s(_vm.pizzaDoughsNeedsCount.pie))
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-card",
        {
          staticClass: "flex-grow-1",
          attrs: {
            "body-class":
              "d-flex justify-content-around dough-counters align-items-center"
          }
        },
        [
          _c(
            "h3",
            { staticClass: "mb-0", attrs: { slot: "header" }, slot: "header" },
            [_vm._v("Раскатано")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Традиционное тесто")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "counter",
                on: {
                  click: function($event) {
                    return _vm.doughRolled(true, false)
                  }
                }
              },
              [
                _c("span", { staticClass: "counter__number" }, [
                  _vm._v(_vm._s(_vm.pizzaDoughRolledCount.big))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Тонкое тесто")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "counter counter_small",
                on: {
                  click: function($event) {
                    return _vm.doughRolled(false, false)
                  }
                }
              },
              [
                _c("span", { staticClass: "counter__number" }, [
                  _vm._v(_vm._s(_vm.pizzaDoughRolledCount.small))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "counter-wrapper" }, [
            _c("h5", { staticClass: "counter-wrapper__header" }, [
              _vm._v("Тесто для пирога")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "counter counter_small",
                on: {
                  click: function($event) {
                    return _vm.doughRolled(true, true)
                  }
                }
              },
              [
                _c("span", { staticClass: "counter__number" }, [
                  _vm._v(_vm._s(_vm.pizzaDoughRolledCount.pie))
                ])
              ]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24685202", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24685202","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PizzaDoughScreen.vue
// module id = null
// module chunks = 